// extracted by mini-css-extract-plugin
module.exports = {"container":"Ah-z","list":"Bh-z"};